import * as React from "react"
import RPNInput from "react-phone-number-input"
import type { Country, Value } from "react-phone-number-input"
import flags from "react-phone-number-input/flags"
import "react-phone-number-input/style.css"
import { cn } from "../../lib/utils"

interface PhoneInputProps {
  value?: string
  onChange?: (value: string) => void
  placeholder?: string
  disabled?: boolean
  className?: string
  id?: string
  name?: string
  autoFocus?: boolean
  defaultCountry?: Country
}

/**
 * Custom input component styled to match shadcn/ui Input
 */
const CustomInput = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      className={cn(
        "flex h-9 w-full rounded-md rounded-l-none border border-l-0 border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      {...props}
    />
  )
)
CustomInput.displayName = "CustomInput"

function PhoneInput({
  value,
  onChange,
  placeholder,
  disabled,
  className,
  id,
  name,
  autoFocus,
  defaultCountry = "ES",
}: PhoneInputProps) {
  return (
    <RPNInput
      international
      defaultCountry={defaultCountry}
      flags={flags}
      value={(value as Value) || undefined}
      onChange={(val) => onChange?.(val || "")}
      placeholder={placeholder}
      disabled={disabled}
      id={id}
      name={name}
      autoFocus={autoFocus}
      inputComponent={CustomInput}
      className={cn("phone-input-container", className)}
    />
  )
}
PhoneInput.displayName = "PhoneInput"

export { PhoneInput }
export type { PhoneInputProps }
